import React from 'react'
import MenuDetailComponent from "../../components/menu_detail/MenuDetailComponent"
import { useEffect } from 'react'
import Page from '../../finwell/pages/Page'

const EditProfilePage = ({condition}) => {
  useEffect(()=>{
    window.scrollTo(0,0);
    
  },[])
  return (
    <Page>
      <MenuDetailComponent condition={condition} />
     
    </Page>
  )
}

export default EditProfilePage
